var impressum = "Impressum";
var privacy = "Prywatność i przepisy prawne";
var recallInfo = "Informacje o wycofaniach";
var signOut = "Wyloguj się";
var pl_pl = {
	impressum: impressum,
	privacy: privacy,
	recallInfo: recallInfo,
	signOut: signOut
};

export { pl_pl as default, impressum, privacy, recallInfo, signOut };
